import styled from '@emotion/styled'
import {COLORS} from '../constants'

/** Borderless icon button that opens the fee breakdown tooltip on hover/focus. */
export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${COLORS.mutedText};
`

/** Heading inside the tooltip body. */
export const TooltipTitle = styled.div`
  margin-bottom: 6px;
  font-weight: 600;
`

/** One fee tier row inside the tooltip: label on the left, percentage on the right. */
export const TierRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 0;
  font-size: 12px;
`

/** Describes which equity band a tier applies to. */
export const TierLabel = styled.span`
  color: ${COLORS.mutedText};
`

/** The fee percentage for a tier. */
export const TierValue = styled.span`
  font-weight: 600;
  color: ${COLORS.success};
`

/**
 * CSS for the MUI Tooltip popper itself — re-skins the default dark bubble into a light
 * card. Passed through emotion's `ClassNames` since MUI v4 needs a class name here.
 */
export const tooltipPopperCss = `
  padding: 12px;
  max-width: 260px;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  background-color: ${COLORS.cardBg};
  color: ${COLORS.foreground};
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
`
